// extracted by mini-css-extract-plugin
export default {"main":"Landingscreen_main__H6Kus"};